/** @format */

import Messages from "./../../library/Messages";

export default class Wishlist {
	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Wishlist();
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(document).on("click", ".js-toggle-wishlist-save", function (e) {
			e.preventDefault();
			self.toggleWishlistItem($(this).data("stockcode"));
		});

		$(document).on("click", ".js-toggle-wishlist-bundle-save", function (e) {
			e.preventDefault();
			self.toggleWishlistBundleItems(
				$(this).data("bundle-id"),
				$(this).data("bundle-stockcodes")
			);
		});

		$(document).on("change", ".js-basket-item-checkbox, .js-quote-item-checkbox", function (e) {
			e.preventDefault();
			self.toggleAddSelectedItemsToBasketBtn($(this));
		});
	}

	toggleWishlistItem(stockcodeId) {
		const self = this,
			$links = $('.js-toggle-wishlist-save[data-stockcode="' + stockcodeId + '"]');

		oc.ajax("savedStockcodes::onToggleStockcodeNonBundleSave", {
			update: {
				"shopWishlist/default": ".js-wishlist-basket",
			},
			data: {
				stockcode_id: stockcodeId,
			},
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);

				self.setWishlistCount(data.count);

				if (data.exists) {
					$links.addClass("is-active");
					Messages.success("Product added to your saved items");
				} else {
					$links.removeClass("is-active");
					Messages.success("Product removed from your saved items");
				}
			},
			error: function (data, responseCode, xhr) {
				Messages.error("An error occurred, please try again");
			},
		});
	}

	toggleWishlistBundleItems(bundleId, stockcodeIds) {
		const self = this,
			$links = $(
				'.js-toggle-wishlist-bundle-save[data-bundle-stockcodes="' +
					JSON.stringify(stockcodeIds) +
					'"]'
			);

		oc.ajax("savedStockcodes::onToggleStockcodeBundleSave", {
			update: {
				"shopWishlist/default": ".js-wishlist-basket",
			},
			data: {
				bundle_id: bundleId,
				stockcode_ids: stockcodeIds,
			},
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);

				self.setWishlistCount(data.count);

				if (data.exists) {
					$links.addClass("is-active");
					Messages.success("Product added to your saved items");
				} else {
					$links.removeClass("is-active");
					Messages.success("Product removed from your saved items");
				}
			},
			error: function (data, responseCode, xhr) {
				Messages.error("An error occurred, please try again");
			},
		});
	}

	setWishlistCount(count) {
		const self = this;

		count = parseInt(count);

		if (count > 0) {
			$(".js-saved-items-count").attr("data-count", count);
		} else {
			$(".js-saved-items-count").removeAttr("data-count");
		}
	}

	toggleAddSelectedItemsToBasketBtn($checkbox) {
		const $form = $checkbox.parents("form");

		// find all checkboxes in the form
		const $checkboxes = $form.find(".js-basket-item-checkbox, .js-quote-item-checkbox");

		// check if any checkbox is checked
		const anyChecked = $checkboxes.is(":checked");

		const $btn = $form.find(".js-toggle-selected-items-to-basket-btn");

		if (anyChecked) {
			$btn.show();
		} else {
			$btn.hide();
		}
	}
}
